import type { ApiService } from "@/domains/api/api-service"

import type { TokenApiDAO, TokenApiResponse } from "./types"
import { convertApiResponseToTokenDAO } from "./types"

export class TokenApiTransport {
  constructor(private apiService: ApiService) {}

  /**
   * Load all tokens from API
   * Pure data loading - no state, no caching, no side effects
   * Converts API response (string addresses) to TokenApiDAO (LcAddress)
   */
  async loadTokens(): Promise<Record<string, TokenApiDAO>> {
    const rawResponse = await this.apiService.getTokens()

    // Convert each token from API format (string address) to DAO format (LcAddress)
    const converted: Record<string, TokenApiDAO> = {}
    Object.entries(rawResponse).forEach(([key, tokenResponse]) => {
      converted[key] = convertApiResponseToTokenDAO(tokenResponse as TokenApiResponse)
    })

    return converted
  }
}
